/** Merge tags for Sponsor/CRO study access notification emails. */
export const SPONSOR_CRO_STUDY_ACCESS_EMAIL_MERGE_TAGS = [
  {
    tag: "{{RecipientName}}",
    entityName: "RecipientName",
    description: "Recipient display name",
  },
  {
    tag: "{{OrganisationName}}",
    entityName: "OrganisationName",
    description: "Customer organisation name",
  },
  {
    tag: "{{StudyName}}",
    entityName: "StudyName",
    description: "Study name",
  },
  {
    tag: "{{Sites}}",
    entityName: "Sites",
    description: "Shared site name(s)",
  },
  {
    tag: "{{Folders}}",
    entityName: "Folders",
    description: "Folder access summary",
  },
  {
    tag: "{{AssignedBy}}",
    entityName: "AssignedBy",
    description: "Person who assigned / updated / removed access",
  },
  {
    tag: "{{ActionDate}}",
    entityName: "ActionDate",
    description: "Action date/time (UTC)",
  },
  {
    tag: "{{LoginUrl}}",
    entityName: "LoginUrl",
    description: "Platform login URL",
  },
];

/** Side-nav sections — add new email types here later (same pattern as QMS config). */
export const SPONSOR_CRO_STUDY_ACCESS_TEMPLATE_META = [
  {
    key: "StudyAccessAssigned",
    title: "Study access assigned",
    subtitle: "New study share",
    icon: "fas fa-user-plus",
    description:
      "Sent when a Sponsor/CRO user is granted access to a study (or additional sites/folders for a new study).",
  },
  {
    key: "StudyAccessUpdated",
    title: "Study access updated",
    subtitle: "Sites or folders changed",
    icon: "fas fa-sync-alt",
    description:
      "Sent when sites or folder access change for a study the user already had.",
  },
  {
    key: "StudyAccessRemoved",
    title: "Study access removed",
    subtitle: "Unshare / deassign",
    icon: "fas fa-user-minus",
    description:
      "Sent when study access is removed (unshare / deassign).",
  },
];
